import { Body, Icon, PresentationListItem } from '@alto/design-system';
import React from 'react';
import { getCompanyName } from '~shared/config/getCompanyName';
import { CONTACT_US_ORIGIN } from '~shared/constants';
import { ContactProgynyActionSheet } from './ContactProgynyActionSheet';

export const LeftoverMedsInfoAndContactProgynyActionSheet = () => (
  <ContactProgynyActionSheet
    origin={CONTACT_US_ORIGIN.LeftOverMedsContactProgynyActionSheet}
    title="Using your extra medication can be safe and effective when following these guidelines"
    footnote={
      <Body center>
        <Body
          center
          fontFamily="semibold"
        >
          Still unsure?
        </Body>{' '}
        We're happy to help. Send us a message or give us a call to speak with a pharmacist at {getCompanyName()}.
      </Body>
    }
  >
    <PresentationListItem
      LeftContent={<Icon name="checkcircle" />}
      text="The expiration date printed on the medication has not yet passed"
    />
    <PresentationListItem
      LeftContent={<Icon name="checkcircle" />}
      text="Room temperature medications have been kept away from direct sunlight or moisture"
    />
    <PresentationListItem
      LeftContent={<Icon name="checkcircle" />}
      text={`Refrigerated medications have been stored appropriately between 36\u00b0F to 46\u00b0F`}
    />
  </ContactProgynyActionSheet>
);
